import React from "react";

const Title = () => {
      return (
            <div className="title1">
                  <b className="learn-how-to">
                        Learn how to launch a successful podcast
                  </b>
                  <div className="lorem-ipsum-is5">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
                  </div>
            </div>
      );
};

export default Title;